// extracted by mini-css-extract-plugin
module.exports = {"suggestion-badge":"suggestion-badge___qNGQR","magic-loop-img":"magic-loop-img___3RhJW"};